import {Space} from "antd";
import {SubSettingsUrlRedirectCheckboxFormField} from "./url-redirect-checkbox-form-field";
import {SubSettingsUrlRedirectLinkFormField} from "./url-redirect-link-form-field";

export function SubSettingsUrlRedirectFormField({
  label = "Redirect customers to URL after purchase",
}: {
  label?: string;
}) {
  return (
    <div>
      <Space size={16} direction="vertical" style={{display: "flex"}}>
        <SubSettingsUrlRedirectCheckboxFormField label={label} />
        <SubSettingsUrlRedirectLinkFormField />
      </Space>
    </div>
  );
}
